import type { SoundSpriteDefinitions } from "howler";
import { noop } from "lodash-es";
import type React from "react";
import { createContext, use } from "react";

import type { GameAnswer, GameMode, GameWord } from "./Game";
import type { GameSettings } from "./GameSettings";

export type GameType = {
  time: number;
  mode: GameMode;
  words: GameWord[];
  answers: GameAnswer[];
  timeLimit: number;
  settings: GameSettings;
  fullName?: string;
};

export const sprite = {
  1: [0, 1000],
  2: [1000, 1000],
  3: [2000, 1000],
  4: [3000, 1000],
  5: [5000, 1000],
  correct: [0, 2000],
  gem: [2000, 3000],
  earn_hint: [5000, 3000],
  use_hint: [8000, 3000],
  skip: [11000, 2000],
  on: [13000, 1000],
  off: [14000, 1000],
  snap: [15000, 1000],
  pop: [16000, 1000],
} satisfies SoundSpriteDefinitions;

export type Sound = keyof typeof sprite;

export const GameContext = createContext<{
  game: GameType;
  header?: React.ReactElement;
  setGame: React.Dispatch<React.SetStateAction<GameType>>;
  resetGame: () => void;
  playSound: (sound: Sound) => void;
  toggleSound: () => void;
  isSoundEnabled: boolean;
}>({
  game: {
    time: 0,
    mode: "classic",
    words: [],
    answers: [],
    timeLimit: 90,
    settings: {
      isFirstLetterShown: true,
      isTypingFeedbackShown: true,
      isHintEnabled: true,
      isTimeRewardEnabled: true,
      isPercentShown: false,
      strictness: {
        cap: false,
        pun: false,
        acc: false,
      },
    },
  },
  setGame: noop,
  resetGame: noop,
  playSound: noop,
  toggleSound: noop,
  isSoundEnabled: true,
});

export const useGame = () => use(GameContext);
